import React, { Fragment, ReactElement } from 'react';
import { Box, Button, Paper, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useHistory, withRouter } from 'react-router'; // import the react-router-dom components
import NavigationConfig from 'navigation/config';
import TranslatedText from '../../components/atoms/translated_text';
import VatReturnListActions from '../../redux/reducers/vatReturn_list_reducer/actions';
import useStyles from './styles';
import DatatableList from './components/datatable';
import clsx from 'clsx';
import AssignmentReturnedIcon from '@material-ui/icons/AssignmentReturned';
import {
  Translations,
  allowedActions,
  TableDefaultFetchValues,
} from './configuration';
import * as AuthSelectors from '../../redux/reducers/gl_auth_reducer/selectors';
import { ModalIDs } from '../../redux/reducers/gl_modal_reducer/types';
import BaseModal from '../../components/molecules/base_modal';
import AddVatReturnForm from 'components/app_common/add_vatreturn';
import ModalActions from '../../redux/reducers/gl_modal_reducer/actions';
// import { StateStatus } from '../../redux/utils/common';
// import * as VatReturnsListSelectors from '../../redux/reducers/vatReturn_list_reducer/selectors';
import AddPaymentForm from './components/add_payment';
import useQuery from 'custom_hooks/useQuery';
import { getState } from 'redux/store';
import { ReducerKeys } from 'redux/reducers';

const VatReturnsPage = (props: any) => {
  // console.log('Render VatReturnsPage');
  const dispatch = useDispatch();
  const classes = useStyles();

  const ROLE = AuthSelectors.useSelectUserRole();

  const query = useQuery();
  const vat_num = query.get('vat_num');
  const period = query.get('period');
  const year = query.get('year');
  const declaration_status = query.get('declaration_status');
  const vat_return_state = query.get('vat_return_state');
  const goBack = query.get('goBack') === 'true' ? true : false;
  let searchParams = {
    ...(vat_num && { vat_num }),
    ...(period && { period }),
    ...(year && { year }),
    ...(declaration_status && { declaration_status }),
    ...(vat_return_state && { vat_return_state }),
  };

  React.useEffect(() => {
    dispatch(VatReturnListActions.fetchSchemeTypesAction());
    dispatch(VatReturnListActions.fetchQuartersAction());
    dispatch(VatReturnListActions.fetchMonthQuarters());
  }, [dispatch]);

  React.useEffect(() => {
    const state = getState(ReducerKeys.VATRETURN_LIST_REDUCER).vatReturnList
      .data;
    // console.log(state);
    dispatch(
      VatReturnListActions.fetchVatReturnListAction({
        sortField:
          state && goBack
            ? state.sorting.sortField
            : TableDefaultFetchValues.TABLE_DEFAULT_SORT_KEY,
        page:
          state && goBack
            ? state.paging.page
            : TableDefaultFetchValues.TABLE_DEFAULT_PAGE,
        pageSize:
          state && goBack
            ? state.paging.pageSize
            : TableDefaultFetchValues.TABLE_DEFAULT_PAGE_SIZE,
        order:
          state && goBack
            ? state.sorting.order
            : TableDefaultFetchValues.TABLE_DEFAULT_ORDER,
        ...searchParams,
      })
    );
  }, [dispatch, searchParams, ROLE]);

  const addVatReturn = () => {
    dispatch(
      ModalActions.openModalAction({
        modalID: ModalIDs.MODAL_ADD_VAT_RETURN,
        params: {
          role: ROLE,
        },
      })
    );
  };

  return (
    <Fragment>
      <Paper
        className={clsx(classes.titleLayout)}
        elevation={0}
        variant={'outlined'}
        square
      >
        <div className={classes.header}>
          <Box display="flex" alignItems={'center'}>
            <AssignmentReturnedIcon style={{ marginRight: '.75rem' }} />
            <Typography component={'p'} variant={'h6'}>
              <TranslatedText
                textMap={Translations.page_title}
                defaultText={Translations.page_title.English}
              />
            </Typography>
          </Box>
          <Box display="flex" alignItems={'center'}>
            {allowedActions.add.roles.includes(ROLE) && (
              <Button className={classes.header_actions} onClick={addVatReturn}>
                <TranslatedText textMap={Translations.add_vat_return} />
              </Button>
            )}
          </Box>
        </div>
      </Paper>
      <div style={{ padding: 12 }}>
        <div className={classes.cardLayout}>
          <Typography
            component={'p'}
            variant={'h5'}
            style={{ marginBottom: '.5rem' }}
          >
            <TranslatedText
              textMap={Translations.manage_vatreturns_title}
              defaultText={Translations.manage_vatreturns_title.English}
            />
          </Typography>
          <Typography component={'p'} variant={'subtitle1'}>
            <TranslatedText
              textMap={Translations.manage_vatreturns_description}
              defaultText={Translations.manage_vatreturns_description.English}
            />
          </Typography>
          <div className={classes.tableList}>
            <div className={classes.tableHeader}>
              <Typography component={'p'} variant={'h5'}>
                <TranslatedText
                  textMap={Translations.table_title}
                  defaultText={Translations.table_title.English}
                />
              </Typography>
            </div>

            <DatatableList ROLE={ROLE} />
          </div>

          <Box display="flex" justifyContent="flex-end">
            <div className={classes.dashboardButton}>
              <BackToDashboardPage />
            </div>
          </Box>
        </div>
      </div>
      <FormModals />
    </Fragment>
  );
};

const BackToDashboardPage = () => {
  const history = useHistory();
  const goToDashboard = () => {
    history.push(NavigationConfig.dashboardPage().path);
  };

  return (
    <Button
      variant="contained"
      style={{ color: '#e6e6e6', backgroundColor: '#25262d' }}
      onClick={goToDashboard}
    >
      <TranslatedText textMap={Translations.go_to_dashboard} />
    </Button>
  );
};

const FormModals = (): ReactElement => {
  return (
    <Fragment>
      <BaseModal
        modalID={ModalIDs.MODAL_ADD_VAT_RETURN}
        renderHeader={() => (
          <TranslatedText textMap={Translations.add_vat_return} />
        )}
        renderContent={(props) => <AddVatReturnForm {...props} />}
      />
      <BaseModal
        modalID={ModalIDs.MODAL_ADD_VAT_RETURN_PAYMENT}
        renderHeader={() => (
          <TranslatedText textMap={Translations.add_vat_return_payment} />
        )}
        renderContent={(props) => <AddPaymentForm {...props} />}
      />
    </Fragment>
  );
};

export default withRouter(VatReturnsPage);
